import React, { useEffect, useState, useContext } from "react";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ContractsSearch from "./ContractsSearch";
import { Card, CardHeader, CircularProgress } from "@mui/material";
import CreateContractReq from "../../../Classes/Models/Requests/Accounting/CreateContractReq";
import AccountingApi from "../../../Classes/API/AccountingApi";
import DataTable from "examples/Tables/DataTable";
import Pagination from "@mui/material/Pagination";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "App";
import SearchStringOrIntReq2 from "Classes/Models/Requests/SearchStringOrIntReq";
import Loader from "Loader";
const index = () => {
  let navigate = useNavigate();

  const [SearchReq, setSearchReq] = useState(new CreateContractReq());
  const [ResponseData, setResposneData] = useState({});
  const [IsLoaded, setIsLoaded] = useState(false);
  const [TableDataRows, setTableDataRows] = useState([]);
  const { translations, switchLanguage } = useContext(LanguageContext);
  const [Page, setPage] = useState(1);
  const [TotalPages, setTotalPages] = useState(0);
  const TableColumns = [
    { Header: translations.sessionWithoutEnteriesid, accessor: "Id", align: "left" },
    { Header: translations.contactssearchName, accessor: "Name", align: "left" },
    { Header: translations.contactssearchDescription, accessor: "Description", align: "left" },
    { Header: translations.contactssearchDetails, accessor: "Details", align: "left" },
    { Header: translations.contactsDownloadDetails, accessor: "Download", align: "left" },
  ];

  const getContractReport = async (id) => {
    let SearchStringOrIntReq = new SearchStringOrIntReq2();

    SearchStringOrIntReq.SearchInt = id;
    var res = await AccountingApi.GetContractReport(SearchStringOrIntReq);
    AccountingApi.downloadContractReportCSV(res);
  };

  const MakeTableRow = (Contract) => {
    return {
      Id: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Contract.id}
        </MDTypography>
      ),
      Name: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Contract.name}
        </MDTypography>
      ),

      Description: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Contract.description}
        </MDTypography>
      ),
      Details: (
        <button
          className="btn btn-primary"
          onClick={() => {
            navigate("/Contracts/Details", { state: { SearchContract: Contract } });
          }}
        >
          {translations.contactssearchDetails}
        </button>
      ),
      Download: (
        <button className="btn btn-primary" onClick={() => getContractReport(Contract.id)}>
          {translations.contactsDownloadDetails}
        </button>
      ),
    };
  };

  const RefreshTable = (resList) => {
    var rows = [];
    resList.forEach((Entry) => {
      rows.push(MakeTableRow(Entry));
    });
    setTableDataRows(rows);
  };

  useEffect(() => {
    if (Object.keys(ResponseData).length > 0) {
      RefreshTable(ResponseData.list);
    }
  }, [ResponseData]);

  useEffect(() => {
    if (Object.keys(ResponseData).length > 0) {
      setIsLoaded(true);
    } else {
      setIsLoaded(false);
    }
  }, [ResponseData]);

  const onSearch = async () => {
    SearchReq.pagingParams.pageNumber = Page;
    console.log(SearchReq);
    let res = await AccountingApi.SearchContracts(SearchReq);
    if (res.status == "Success") {
      console.log(res);
      setResposneData(res.data);
      setTotalPages(res.data.totalPages);
      Swal.close();
    }
  };

  useEffect(() => {
    setIsLoaded(true);
    console.log(SearchReq);
    onSearch();
  }, [SearchReq]);

  useEffect(() => {
    onSearch();
  }, [Page]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ContractsSearch setSearchReq={setSearchReq} />
      {!IsLoaded ? (
        <Loader />
      ) : (
        <Card className="mt-5">
          <MDBox
            mx={4}
            mt={-3}
            py={3}
            px={2}
            sx={{ backgroundColor: "#3560AD" }}
            borderRadius="lg"
            coloredShadow="info"
          >
            <div className="text-center">
              <MDTypography variant="h6" color="white">
                {translations.contactssearchContractContracts}
              </MDTypography>
            </div>
          </MDBox>

          <DataTable
            table={{ columns: TableColumns, rows: TableDataRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />

          <div className="text-right mx-3 my-4">
            <Pagination
              count={TotalPages}
              onChange={(e, num) => setPage(num)}
              color="primary"
              className="float-right"
            />
          </div>
        </Card>
      )}
    </DashboardLayout>
  );
};

export default index;
